/**
 * Adaptateur PayPal (Smart Payment Buttons)
 */
export async function processPaypal({ amount, currency, description, customer, config }) {
  console.log('🚀 Initializing PayPal Checkout...', { amount, currency });

  return new Promise((resolve, reject) => {
    // 1. Chargement dynamique du SDK PayPal
    const scriptId = 'paypal-sdk-script';
    let script = document.getElementById(scriptId);

    if (script) {
      document.head.removeChild(script);
    }

    script = document.createElement('script');
    script.id = scriptId;
    script.src = `https://www.paypal.com/sdk/js?client-id=${config.clientId}&currency=${currency.toUpperCase()}&disable-funding=credit,card`;
    
    script.onload = () => {
      // 2. Création d'un conteneur temporaire pour le bouton
      const overlay = document.createElement('div');
      overlay.id = 'paypal-overlay';
      overlay.style = "position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.8);z-index:99999;display:flex;align-items:center;justify-content:center;flex-direction:column;gap:20px;backdrop-filter:blur(5px);";
      overlay.innerHTML = `
        <div style="background:white;padding:30px;border-radius:16px;text-align:center;min-width:340px;box-shadow:0 20px 25px -5px rgba(0,0,0,0.1);">
          <h3 style="margin-bottom:10px;color:#111;font-family:sans-serif;font-weight:700;">Finaliser le paiement</h3>
          <p style="margin-bottom:25px;color:#666;font-size:14px;font-family:sans-serif;">${description} - <b>${amount} ${currency.toUpperCase()}</b></p>
          <div id="paypal-button-container"></div>
          <button id="cancel-paypal" style="margin-top:20px;background:none;border:none;color:#999;cursor:pointer;font-size:13px;text-decoration:none;transition:color 0.2s;">Annuler et fermer</button>
        </div>
      `;
      document.body.appendChild(overlay);

      // 3. Rendu du bouton PayPal
      window.paypal.Buttons({
        createOrder: (data, actions) => {
          return actions.order.create({
            purchase_units: [{
              description: description,
              amount: {
                currency_code: currency.toUpperCase(),
                value: amount.toString()
              }
            }]
          });
        },
        onApprove: async (data, actions) => {
          const details = await actions.order.capture();
          document.body.removeChild(overlay);
          resolve({
            success: true,
            transactionId: details.id,
            provider: 'paypal',
            data: details
          });
        },
        onCancel: () => {
          if (document.getElementById('paypal-overlay')) {
            document.body.removeChild(overlay);
          }
          resolve({ success: false, error: 'Paiement annulé par l’utilisateur.' });
        },
        onError: (err) => {
          if (document.getElementById('paypal-overlay')) {
            document.body.removeChild(overlay);
          }
          console.error('PayPal Error:', err);
          resolve({ success: false, error: 'Erreur technique lors du paiement PayPal.' });
        }
      }).render('#paypal-button-container');

      document.getElementById('cancel-paypal').onclick = () => {
        document.body.removeChild(overlay);
        resolve({ success: false, error: 'Paiement annulé.' });
      };
    };

    script.onerror = () => reject(new Error('Impossible de charger le SDK PayPal.'));
    document.head.appendChild(script);
  });
}
